import { 
	ApplicationIssue,
} from 'src/app/database-models';

export class ApplicationIssueLookupGroup {
	applicationIssue : ApplicationIssue;
}
